// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { harvestAttributeCodeCode } from './HarvestAttributeCode';
import { z } from 'zod';
export const harvestOperationTemplateUpstreamDepId = (z.number());
export const harvestOperationTemplateUpstreamDep = z.object({
    id: harvestOperationTemplateUpstreamDepId,
    operation_template_id: harvestOperationTemplateRevisionId,
    code: harvestAttributeCodeCode,
    created_at: z.date(),
    updated_at: z.date(),
});
export const harvestOperationTemplateUpstreamDepInitializer = z.object({
    id: harvestOperationTemplateUpstreamDepId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId,
    code: harvestAttributeCodeCode,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const harvestOperationTemplateUpstreamDepMutator = z.object({
    id: harvestOperationTemplateUpstreamDepId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId.optional(),
    code: harvestAttributeCodeCode.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=HarvestOperationTemplateUpstreamDep.js.map